import createLucideIcon from '../createLucideIcon';

const RefreshCcw = createLucideIcon('RefreshCcwIcon', [
  ['path', { d: 'M3 2v6h6', key: '18ldww' }],
  ['path', { d: 'M21 12A9 9 0 0 0 6 5.3L3 8', key: '1pbrqz' }],
  ['path', { d: 'M21 22v-6h-6', key: 'usdfbe' }],
  ['path', { d: 'M3 12a9 9 0 0 0 15 6.7l3-2.7', key: '1hosoe' }],
]);

export default RefreshCcw;
